module.exports = __webpack_public_path__ + "media/9b_ASANBUDAPEST-BASS9b.ea3f04dd.mp3";